import script from "./FormularioComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioComponente.vue?vue&type=script&setup=true&lang=js"

import "./FormularioComponente.vue?vue&type=style&index=0&id=29b87484&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b87484"]])

export default __exports__